// extracted by mini-css-extract-plugin
export default {"spinner":"Loading_spinner__n1rhz","spin":"Loading_spin__jVJJv"};